'use client'

import { useTranslations } from 'next-intl'

import { HeaderControl } from '@maestro/commerce-blocks/components/header-controls'
import { useMobileNavigation } from '@maestro/commerce-blocks/providers/mobile-navigation/context'

export default function NavigationMobileToggleButton() {
  const { openMenu } = useMobileNavigation()
  const t = useTranslations('commerce-blocks')

  return (
    <HeaderControl
      icon="menu"
      title={t('navigation-header.open-mobile-menu')}
      onClick={openMenu}
      customClassName="header-control--mobile-menu"
    />
  )
}
